import type { RawPageConfig } from '~/types/page-config'
import { curaboxBaseConfig, pflegeServicesBaseConfig } from './base'

const curabox = {
  ...curaboxBaseConfig,
  etUrl: 'https://curabox-pages-dev-sandbox.pflege.de/et/get-session-data',
}

const pflegeServices = {
  ...pflegeServicesBaseConfig,
  etUrl: 'https://service.pflege.de/et/get-session-data',
}

const config: RawPageConfig[] = [
  {
    ...curabox,
    domain: 'sepac-curabox.development.p4e.io',
    storyblok: {
      ...curabox.storyblok,
      tokenNuxtRuntimeName: 'curaboxPublishedAccessToken',
      accessLevel: 'published',
    },
  },
  {
    ...curabox,
    domain: ['sepac-curabox-draft.development.p4e.io', 'sepac-dev-sandbox.webdev.p4e.io'],
    storyblok: {
      ...curabox.storyblok,
      tokenNuxtRuntimeName: 'curaboxDraftAccessToken',
      accessLevel: 'draft',
    },
  },
  {
    ...pflegeServices,
    domain: 'sepac-services.development.p4e.io',
    storyblok: {
      ...pflegeServicesBaseConfig.storyblok,
      tokenNuxtRuntimeName: 'pflegeServicesPublishedAccessToken',
      accessLevel: 'published',
    },
  },
  {
    ...pflegeServices,
    domain: 'sepac-services-draft.development.p4e.io',
    storyblok: {
      ...pflegeServicesBaseConfig.storyblok,
      tokenNuxtRuntimeName: 'pflegeServicesDraftAccessToken',
      accessLevel: 'draft',
    },
  },
]

export default config
